/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import type { Board } from 'app/scripts/models/Board';
import type { ViewOptions } from 'app/scripts/views/internal/View';
import { View } from 'app/scripts/views/internal/View';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { BoardMenuEmailTemplate } from 'app/scripts/views/templates/BoardMenuEmailTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface EditEmailSettingsViewOptions extends ViewOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fromPowerUpDirectory?: any;
}

interface EditEmailSettingsView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allowEmail: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fromPowerUpDirectory: any;
}

class EditEmailSettingsView extends View<Board, EditEmailSettingsViewOptions> {
  static initClass() {
    this.prototype.viewTitleKey = 'add cards via email';

    this.prototype.events = {
      // @ts-expect-error TS(2339): Property 'events' does not exist on type 'EditEmai... Remove this comment to see the full error message
      'change .js-select-position': 'updatePosition',
      'change .js-select-list': 'updateList',
      'click .js-generate-address': 'generateAddress',
      'click .js-send-address': 'sendAddressEmail',
      'click .js-autofocus': 'focusInput',
    };
  }

  initialize(options: EditEmailSettingsViewOptions) {
    const { fromPowerUpDirectory } = options;
    super.initialize(options);
    this.listenTo(
      this.modelCache,
      'add:List remove:List change:List:closed reset:List',
      this.frameDebounce(this.render),
    );
    this.listenTo(
      this.model,
      'change:myPrefs',
      this.frameDebounce(this.render),
    );

    this.allowEmail = true;

    if (this.model.getPref('emailKey') == null) {
      return this.model.generateEmailKey();
    }
    this.fromPowerUpDirectory = fromPowerUpDirectory ?? false;
  }

  render() {
    let list;
    if (this.model.canComment(Auth.me())) {
      let left;
      const idSelectedList = this.model.getPref('idEmailList');

      // eslint-disable-next-line @typescript-eslint/no-shadow
      const lists = this.model.listList.models.map((list) => ({
        id: list.id,
        name: list.get('name'),
      }));

      const selectedListName = (() => {
        if ((list = _.findWhere(lists, { id: idSelectedList })) != null) {
          return list.name;
        } else if (
          (list = ModelCache.get('List', idSelectedList)) != null &&
          list.get('closed')
        ) {
          const archivedName = l('archived list', {
            listName: list.get('name'),
          });
          lists.unshift({ id: list.id, name: archivedName });
          return archivedName;
        } else {
          if (idSelectedList != null) {
            // Load list into cache then rerender, grabbing it from cache.
            ModelLoader.loadArchivedListsAndCards(this.model.id).then(() => {
              // Only re-render if we actually found the list; if the list was
              // moved to another board, we're never going to find it
              if (ModelCache.get('List', idSelectedList) != null) {
                return this.render();
              }
            });
          }
          return l('unknown list placeholder');
        }
      })();

      if (idSelectedList == null) {
        lists.unshift({
          name: l('unknown list placeholder'),
          // @ts-expect-error
          selected: true,
        });
      }

      this.$el.html(
        BoardMenuEmailTemplate({
          commentsEnabled: true,
          email: (left = this.model.getPref('fullEmail')) != null ? left : '',
          /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
          lists: lists.map((list: any) => ({
            id: list.id,
            name: list.name,
            selected: list.id === idSelectedList,
          })),
          listName: selectedListName,
          positionName: l([
            'email position',
            this.model.getPref('emailPosition'),
          ]),
          position: this.model.getPref('emailPosition'),
        }),
      );
      this.$el.find('#boardEmail').on('copy', () => {
        Analytics.sendTrackEvent({
          action: 'copied',
          actionSubject: 'email',
          source: 'emailToBoardSettingsInlineDialog',
          attributes: {
            fromPowerUpDirectory: this.fromPowerUpDirectory,
          },
          containers: {
            board: {
              id: this.model.id,
            },
          },
        });
      });
    } else {
      this.$el.html(
        BoardMenuEmailTemplate({
          commentsEnabled: false,
        }),
      );
    }

    Analytics.sendScreenEvent({
      name: 'emailToBoardSettingsInlineDialog',
      attributes: {
        fromPowerUpDirectory: this.fromPowerUpDirectory,
      },
      containers: {
        board: {
          id: this.model.id,
        },
      },
    });

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  focusInput(e: any) {
    $(e.target).focus().select();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateValue(selectName: any, prefName: any) {
    const val = this.$el.find(selectName).val();

    if (val != null && val !== this.model.getPref(prefName)) {
      return this.model.setPref(prefName, val);
    }
  }

  updatePosition() {
    return this.updateValue('.js-select-position', 'emailPosition');
  }

  updateList() {
    this.updateValue('.js-select-list', 'idEmailList');
    return (this.allowEmail = true);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  generateAddress(e: any) {
    stopPropagationAndPreventDefault(e);

    Confirm.pushView('regenerate email address', {
      model: this.model,
      confirmBtnClass: 'nch-button nch-button--danger',
      popOnClick: true,
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
      fxConfirm: (e: any) => {
        this.model.set({
          'myPrefs/emailKey': null,
        });

        this.allowEmail = true;

        Analytics.sendClickedButtonEvent({
          // @ts-expect-error TS(2322): Type '"regenerateE2BAddressButton"' is not assigna... Remove this comment to see the full error message
          buttonName: 'regenerateE2BAddressButton',
          source: 'emailToBoardSettingsInlineDialog',
          attributes: {
            fromPowerUpDirectory: this.fromPowerUpDirectory,
          },
          containers: {
            board: {
              id: this.model.id,
            },
          },
        });

        return this.model.generateEmailKey();
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendAddressEmail(e: any) {
    stopPropagationAndPreventDefault(e);

    if (!this.allowEmail) {
      return;
    }

    Analytics.sendClickedButtonEvent({
      // @ts-expect-error TS(2322): Type '"sendE2BAddressButton"' is not assignable to... Remove this comment to see the full error message
      buttonName: 'sendE2BAddressButton',
      source: 'emailToBoardSettingsInlineDialog',
      attributes: {
        fromPowerUpDirectory: this.fromPowerUpDirectory,
      },
      containers: {
        board: {
          id: this.model.id,
        },
      },
    });

    this.allowEmail = false;
    this.model.api(
      {
        method: 'emailKey/message',
        type: 'post',
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (err: any) => {
        if (!err) {
          return Alerts.flash('email sent', 'confirm', 'email');
        } else {
          return Alerts.show('could not send email', 'error', 'email', 5000);
        }
      },
    );
  }
}

EditEmailSettingsView.initClass();
export { EditEmailSettingsView };
